document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('template-page')) return;

  var form = document.querySelector('.hbspt-form');

  if (form && !form.closest('.page-services-section')) {
  
  form.style.overflow = 'hidden';
  form.style.maxHeight = '0';
  form.style.transition = 'max-height 0.4s ease';

  
  var button = document.createElement('button');
  button.type = 'button';
  button.textContent = 'Get In Touch';
  button.className = 'btn tread hubspot-form-toggle';

  button.addEventListener('click', function () {
    if (form.style.maxHeight === '0px' || form.style.maxHeight === '0') {

      form.style.maxHeight = form.scrollHeight + 'px';
    } else {
  
      form.style.maxHeight = '0';
    }
  });

  form.parentNode.insertBefore(button, form);
  }

});


$(function() {

    $(document).on('click', '#vehicle-showcase-btn', function() {
      $('#vehicle-showcase').fadeIn();
    });

    $('.close-showcase').click(function() {
      $('#vehicle-showcase').fadeOut();
    });

    // Breadcrumb for Vechicle Showcases
    $(window).on('beforeunload', function() {
      localStorage.setItem('previousBodyClass', $('body').attr('class'));
    });

    var previousBodyClass = localStorage.getItem('previousBodyClass');
    if (previousBodyClass) {
      if (previousBodyClass.includes('showcase')) {

        var previousURL = document.referrer;
        if (previousURL) {
          $.ajax({
            url: previousURL,
            success: function(html) {
              var previousTitle = $(html).filter('title').text();
              let previousTitleStripped = previousTitle.replace("– Main Line Overland", "");
              // $('.breadcrumbs .shop-breadcrumb').text(previousTitleStripped);
              $('.breadcrumbs .shop-breadcrumb').html('<a href='+previousURL+'>'+previousTitleStripped+'</a>');
            },
            error: function() {
               console.log("Error retrieving previous page content.");
            }
          });
        } else {
          console.log("No previous page in history.");
        }
        // alert("Previous page had the class: showcase");
      } else {
        // console.log("Previous page did not have the class: your-class-name");
        // alert("Previous page did not have the class: showcase");
      }
      localStorage.removeItem('previousBodyClass'); // Clear the stored class
    }







    // $('.js-ymm').click(function() {
    //   $('#make-model-search, #overlay').fadeToggle();
    // });

    $('.mobile-search').click(function() {
      $('#search').fadeToggle();
    });

    $('#overlay').click(function() {
      $(this).fadeToggle();
      $('#make-model-search').fadeToggle();
    });

    // $('.home-hero-js').slick({
    //   autoplay: true,
    //   dots: true,
    //   arrows:false,
    //   infinite: true,
    //   autoplaySpeed: '7000',
    //   speed: '900',
    //   fade: true
    // });

    $('.intro-carousel-js').slick({
      autoplay: true,
      dots: false,
      arrows:false,
      infinite: true,
      slidesToShow: 1,
      autoplaySpeed: '3000',
      speed: '900',
      fade: true
    });

    $('#filters .filter-group h3').click(function() {
      $(this).toggleClass('open');
      $(this).parent().toggleClass('open');
      $(this).parent().find('ul').slideToggle();

    });

    $('.mobile-collection-filters .btn').click(function() {
      $('#filters').toggleClass('filters-open');
    });

    $('#filters .filters-close').click(function() {
      $('#filters').toggleClass('filters-open');
    });

    // Tabs
    $('.tabs a').click(function() {
      var selectedTab = $(this).attr('href');
      $('.tabs-content li').hide().removeClass('active');
      $('.tabs-content li'+selectedTab).show().addClass('active');
      $('.tabs a').removeClass('active');
      $(this).addClass('active');
      $("html, body").animate({ scrollTop: 0 }, "slow");
    });

    // Light Box
    const lightbox = GLightbox({
      selector: '.lightbox',
      touchNavigation: true,
      loop: true,
      autoplayVideos: true
    });



    // var shopMenuOther = $('.main-nav-shop .site-nav__childlist-grid .site-nav__childlist-item:not(:first-of-type)');
    // $('<div class="shop-right">'+shopMenuOther+'</div>').appendTo('.main-nav-shop .site-nav__childlist-grid');

    // var shopMenuOther = $(".main-nav-shop .site-nav__childlist-grid .site-nav__childlist-item").slice(1);
    // $('<div class="shop-right">'+$(shopMenuOther)+'</div>').appendTo('.main-nav-shop .site-nav__childlist-grid');


    $(window).on("resize", function () {
      var $theWindowSize = $(this).width();
      if($theWindowSize > 992)  {
        // Desktop


        $('#ProductSection-product-template .product-single__media-group').filter('.slick-initialized').slick('unslick');


      } else if ($theWindowSize > 767) {

      } else {
        // Mobile

        $(function() {
          $('#ProductSection-product-template .product-single__media-group').not('.slick-initialized').slick({
            dots: false,
            arrows: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed: '7000',
            speed: '500'
          });

        });

      }
    }).resize();

});
